module.exports = __webpack_public_path__ + "static/img/recall-rule.6886daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/sixthAnniveRecall/recall/recall-rule.png
// module id = IXJc
// module chunks = 1